// extracted by mini-css-extract-plugin
module.exports =  {"suffix":"AxmY9HBj4OgHqBtybO1H"};